import {
  StudentStudentGetMyLiveClassByMyIdDocument,
  StudentStudentGetMyLiveClassByMyIdQuery,
  StudentStudentGetMyLiveClassByMyIdQueryVariables,
} from "../types";
import { client } from "../../client";

export async function studentGetLiveClasses(
  variables: StudentStudentGetMyLiveClassByMyIdQueryVariables
): Promise<StudentStudentGetMyLiveClassByMyIdQuery> {
  try {
    const response = await client.query<
      StudentStudentGetMyLiveClassByMyIdQuery,
      StudentStudentGetMyLiveClassByMyIdQueryVariables
    >({
      query: StudentStudentGetMyLiveClassByMyIdDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return response.data;
  } catch (e) {
    throw e;
  }
}
